import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Birds of a Feather",
  date: new Date(2024, 2, 4),
  img: "/img/birds.jpeg",
  tracks: [
    {
      title: "New Toys",
      src: "/songs/2024-03-04/new_toys.mp3",
      duration: 602.52,
    },
    {
      title: "Seduce You",
      src: "/songs/2024-03-04/seduce_you.mp3",
      duration: 1209.576,
    },
    {
      title: "Dude Ranch",
      src: "/songs/2024-03-04/dude_ranch.mp3",
      duration: 1083.24,
    },
    {
      title: "Burning Yearning",
      src: "/songs/2024-03-04/burning_yearning.mp3",
      duration: 787.752,
    },
    {
      title: "Ticket To Birmingham",
      src: "/songs/2024-03-04/ticket_to_birmingham.mp3",
      duration: 617.496,
    },
    {
      title: "Sometimes It's Nice To Play A Song",
      src: "/songs/2024-03-04/sometimes_its_nice_to_play_a_song.mp3",
      duration: 474.48,
    },
    {
      title: "Xylophone X-Ray",
      src: "/songs/2024-03-04/xylophone_x_ray.mp3",
      duration: 875.952,
    },
    {
      title: "High Stakes",
      src: "/songs/2024-03-04/high_stakes.mp3",
      duration: 1307.568,
    },
    {
      title: "Dodging Bullets",
      src: "/songs/2024-03-04/dodging_bullets.mp3",
      duration: 1492.008,
    },
  ],
};
export default album;
